import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5599e050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row filterRow d-none d-sm-flex" }
const _hoisted_2 = {
  key: 0,
  class: "col-3"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filterHeader" }, "Deposit Amount", -1))
const _hoisted_4 = {
  key: 1,
  class: "col-3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filterHeader" }, "Your Region", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "form-control",
  id: "filter_zip",
  type: "search",
  autocomplete: "off",
  spellcheck: "false",
  placeholder: "Enter zip, city, or state"
}, null, -1))
const _hoisted_7 = {
  key: 2,
  class: "col-3"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filterHeader" }, "Availability", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "branch" }, "Local Branches only", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "online" }, "Online only", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "branchAndOnline" }, "Branches & Online", -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "col-3"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filterHeader" }, "Institution Type", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bank" }, "Banks", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "credit" }, "Credit Unions", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bankAndCredit" }, "Banks & Credit Unions", -1))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "linkSection" }
const _hoisted_20 = {
  key: 0,
  class: "cuIndustries animated fadeIn d-none d-sm-block"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filterHeader" }, "Include Additional Credit Unions", -1))
const _hoisted_22 = { class: "linkSection" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("By default, only credit unions with easy membership requirements are included in the search results. To include additional credit unions, select the industries below that you or your "),
  /*#__PURE__*/_createElementVNode("b", null, "immediate family"),
  /*#__PURE__*/_createTextVNode(" members currently or previously worked in.")
], -1))
const _hoisted_24 = { class: "row filterRow" }
const _hoisted_25 = ["id", "name", "value"]
const _hoisted_26 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("input", {
      type: "hidden",
      id: "dmaHid",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.dma) = $event))
    }, null, 512), [
      [_vModelText, _ctx.filter.dma]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "hidden",
      id: "stateHid",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.state) = $event))
    }, null, 512), [
      [_vModelText, _ctx.filter.state]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "hidden",
      id: "regionFilterName",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.region) = $event))
    }, null, 512), [
      [_vModelText, _ctx.filter.region]
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showDepositAmountAndEstEarning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "depositAmount",
              type: "text",
              placeholder: "$25,000",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.depositAmount) = $event)),
              onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setDepositAmount && _ctx.setDepositAmount(...args))),
              onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.setDepositAmount && _ctx.setDepositAmount(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.depositAmount]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showRegionFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createVNode(_Transition, {
              name: "fade-with-background",
              duration: { enter: 2000, leave: 0 },
              appear: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("label", {
                  id: "filter_region",
                  key: _ctx.filter.region,
                  class: "dma"
                }, _toDisplayString((_ctx.filter.region) ? _ctx.filter.region : 'Nationwide Only'), 1))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.showAvailabilityFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              name: "availability",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filter.availability) = $event))
            }, _hoisted_12, 512), [
              [_vModelSelect, _ctx.filter.availability]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showInstitutionFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              name: "institution",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filter.institutionType) = $event))
            }, _hoisted_18, 512), [
              [_vModelSelect, _ctx.filter.institutionType]
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.filter.institutionType === 'credit' || _ctx.filter.institutionType === 'bankAndCredit')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "linkText",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.show = !_ctx.show))
                  }, _toDisplayString(_ctx.show ? 'Collapse' : 'Expand') + " Credit Union Options", 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.show && (_ctx.filter.institutionType === 'credit' || _ctx.filter.institutionType === 'bankAndCredit'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createTextVNode(),
              _createElementVNode("span", _hoisted_22, [
                _createElementVNode("a", {
                  class: "linkText",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.selectAllUnionOptions && _ctx.selectAllUnionOptions(...args)))
                }, "(" + _toDisplayString(_ctx.isAllUnionOption ? 'Include' : 'Exclude') + " All Affiliations)", 1)
              ]),
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unionOptions, (unionOption) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: unionOption.value,
                    class: "col-4 col-md-3"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: unionOption.value,
                      name: unionOption.value,
                      value: unionOption.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filter.selectedUnionOptions) = $event))
                    }, null, 8, _hoisted_25), [
                      [_vModelCheckbox, _ctx.filter.selectedUnionOptions]
                    ]),
                    _createElementVNode("label", {
                      for: unionOption.value
                    }, _toDisplayString(unionOption.displayText), 9, _hoisted_26)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}